<!-- eslint-disable max-len -->
<template>
  <div>
    <div id="app" class="overflow-hidden" v-bind:class="{ hiddenScroll: loading }">
      <div class="site-wrapper absolute top-2 right-0 mr-2 z-50 w-auto">
        <transition name="status">
          <div
            class="my-2 p-2 pb-0 rounded-lg secondary-back flex flex-row w-full"
            v-if="statusMsg"
          >
            <p class="pl-1 pt-1">{{ statusMsg }}</p>
            <p
              class="opacity-75 cursor-pointer pt-1 pl-3 float-right hover:opacity-100"
              @click="statusMsg = null"
            >
              ×
            </p>
          </div>
        </transition>
      </div>
      <spinner :loading="loading" />
      <router-view ref="routerView" />
    </div>
  </div>
</template>

<script>
import store from '@/store';
import spinner from '@/components/spinner.vue';

export default {
  name: 'app',
  components: {
    spinner,
  },
  store,
  data() {
    return {
      statusMsg: null,
    };
  },
  computed: {
    loading() {
      return store.state.loading;
    },
  },
  mounted() {
    let timer = -1;
    this.$root.$on('status-message', (msg) => {
      clearTimeout(timer);
      this.statusMsg = msg;
      timer = setTimeout(() => {
        this.statusMsg = null;
      }, 5 * 1000);
    });
  },
};
</script>

<style>
.hiddenScroll {
  overflow: hidden !important;
  ::-webkit-scrollbar {
    display: none;
  }
}

.secondary-back {
  background-color: #c9d99e;
}
.status-enter-active,
.status-leave-active {
  transition: opacity 0.5s;
}
.status-enter,
.status-leave-to {
  opacity: 0;
}
</style>
